import { FormattedMessage } from '../../util/reactIntl';

export const CustomQuoteRequestLink = () => (
  <a href="https://event.youna.co/fr/demande-de-devis" target="_blank" className="text-center mt-4">
    <FormattedMessage id="BookingTimeForm.customQuoteRequestLink" />
  </a>
);
